/* Barklypaw — base theme behavior
   Vanilla JS, progressive enhancement. Page-specific JS is added per build. */
(function () {
  'use strict';

  function redirectStaleHomeCache() {
    if (window.location.pathname !== '/' || window.location.search || window.location.hash) return;
    var staleHero = document.querySelector('.bp-hero .bp-center');
    if (!staleHero || staleHero.textContent.indexOf('Select a product for this section') === -1) return;
    window.location.replace('/?view=main');
  }

  function hardenInternalLinks() {
    var fixedHome = '/?view=main';
    var fixedProduct = '/products/barklypaw-cooling-mat-1plus1';

    document.querySelectorAll('a.header__heading-link[href="/"], a.header__heading-link[href="/?"]').forEach(function (link) {
      link.setAttribute('href', fixedHome);
    });

    document.querySelectorAll('a[href="/pages/barklypaw-home"]').forEach(function (link) {
      link.setAttribute('href', fixedProduct);
    });

    document.querySelectorAll('a[href="/products/barklypaw-cooling-mat"], a[href="/products/barklypaw-cooling-mat?view=main"]').forEach(function (link) {
      link.setAttribute('href', fixedProduct);
    });
  }

  /* --- Mobile menu toggle ------------------------------------------------ */
  function initMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-menu]');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });
  }

  /* --- Accessibility widget (IS 5568) ----------------------------------- */
  function initA11y() {
    var root = document.querySelector('[data-a11y]');
    if (!root) return;
    if (root.getAttribute('data-a11y-managed') === 'section') return;
    var toggle = root.querySelector('.a11y__toggle');
    var panel = root.querySelector('.a11y__panel');
    var KEY = 'barklypaw:a11y';
    var MODES = ['contrast', 'links', 'headings', 'readable', 'spacing', 'animations'];
    var state = {};
    try { state = JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { state = {}; }

    function apply() {
      document.documentElement.style.setProperty('--font-body-scale', state.fontScale || 1);
      MODES.forEach(function (m) {
        document.body.classList.toggle('a11y--' + m, !!state[m]);
        var btn = root.querySelector('[data-a11y-action="' + m + '"]');
        if (btn) btn.setAttribute('aria-pressed', state[m] ? 'true' : 'false');
      });
    }
    function save() {
      try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {}
    }

    apply();

    function openPanel(open) {
      if (!toggle || !panel) return;
      toggle.setAttribute('aria-expanded', String(open));
      panel.hidden = !open;
      if (open) { var f = panel.querySelector('button'); if (f) f.focus(); }
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        openPanel(toggle.getAttribute('aria-expanded') !== 'true');
      });
    }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-a11y-close]')) {
        openPanel(false);
        if (toggle) toggle.focus();
        return;
      }
      var btn = e.target.closest('[data-a11y-action]');
      if (!btn) return;
      var action = btn.getAttribute('data-a11y-action');
      if (action === 'font-up') state.fontScale = Math.min((state.fontScale || 1) + 0.1, 1.6);
      else if (action === 'font-down') state.fontScale = Math.max((state.fontScale || 1) - 0.1, 0.8);
      else if (action === 'reset') state = {};
      else state[action] = !state[action];
      apply();
      save();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel && !panel.hidden) {
        openPanel(false);
        if (toggle) toggle.focus();
      }
    });
  }

  /* --- Add to cart ------------------------------------------------------- */
  function cartRoutes() {
    var r = window.routes || {};
    return { cart: r.cart_url || '/cart' };
  }

  function bundleCartUrl(variantId) {
    return cartRoutes().cart + '/' + encodeURIComponent(String(variantId)) + ':2?storefront=true';
  }

  function initAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-product-form]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      var idInput = form.querySelector('[name="id"]');
      if (!idInput || !idInput.value) {
        if (btn) btn.disabled = false;
        return;
      }
      window.location.href = bundleCartUrl(idInput.value);
    });
  }

  /* --- Product gallery: thumbnail swap ---------------------------------- */
  function initGallery() {
    var main = document.getElementById('pdp-main-img');
    if (!main) return;
    var thumbs = document.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var full = thumb.getAttribute('data-full');
        if (full) main.src = full;
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      });
    });
  }

  /* --- Product form: variant (color/size) selection --------------------- */
  function initProductForm() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;
    var dataEl = form.parentNode.querySelector('[data-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var selected = {};
    form.querySelectorAll('[data-option-position].is-selected').forEach(function (b) {
      selected[b.getAttribute('data-option-position')] = b.getAttribute('data-value');
    });

    function matchVariant() {
      return variants.filter(function (v) {
        var ok = true;
        ['1', '2', '3'].forEach(function (p) {
          if (selected[p] != null && v['option' + p] !== selected[p]) ok = false;
        });
        return ok;
      })[0];
    }

    function refresh() {
      var v = matchVariant();
      if (!v) return;
      var idInput = form.querySelector('[name="id"]');
      if (idInput) idInput.value = v.id;
      var priceEl = form.querySelector('[data-price]');
      if (priceEl) priceEl.textContent = v.price;
      var cmpEl = form.querySelector('[data-price-compare]');
      if (cmpEl) cmpEl.textContent = v.compare;
      var submit = form.querySelector('[type="submit"]');
      if (submit) submit.disabled = !v.available;
    }

    form.querySelectorAll('[data-option-position]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = btn.getAttribute('data-option-position');
        selected[pos] = btn.getAttribute('data-value');
        form.querySelectorAll('[data-option-position="' + pos + '"]').forEach(function (b) {
          b.classList.toggle('is-selected', b === btn);
        });
        var disp = form.querySelector('[data-opt-display="' + pos + '"]');
        if (disp) disp.textContent = btn.getAttribute('data-value');
        refresh();
      });
    });
  }

  /* --- Accessibility hardening for cached Shopify fragments -------------- */
  function hardenRenderedAccessibility() {
    var policyLabels = {
      'shipping-policy': 'Shipping Policy',
      'refund-policy': 'Refund Policy',
      'privacy-policy': 'Privacy Policy',
      'terms-of-service': 'Terms of Service',
      'contact-information': 'Contact Information',
      'terms-of-sale': 'Terms of Sale',
      'legal-notice': 'Legal Notice'
    };
    Object.keys(policyLabels).forEach(function (key) {
      if (window.location.pathname.indexOf('/policies/' + key) === -1) return;
      var label = policyLabels[key];
      document.querySelectorAll('h1').forEach(function (heading) {
        heading.textContent = label;
      });
      document.title = label + ' - BarklyPaw';
      document.querySelectorAll('meta[property="og:title"], meta[name="twitter:title"]').forEach(function (meta) {
        meta.setAttribute('content', label);
      });
    });

    document.querySelectorAll('.scroll-trigger.animate--slide-in, .scroll-trigger.animate--fade-in').forEach(function (el) {
      el.classList.remove('scroll-trigger', 'animate--slide-in', 'animate--fade-in');
      el.style.animation = 'none';
      el.style.opacity = '1';
      el.style.transform = 'none';
    });

    document.querySelectorAll('.footer__copyright').forEach(function (el) {
      el.remove();
    });

    document.querySelectorAll('.bp-footer-legal').forEach(function (el) {
      el.style.background = '#fffaf5';
      el.style.color = '#1c1a18';
    });

    document.querySelectorAll('.bp-footer-legal a').forEach(function (el) {
      el.style.background = '#fffaf5';
      el.style.color = '#1c1a18';
      el.style.opacity = '1';
    });

    document.querySelectorAll('.contact, .contact .title, .contact .form__message, .contact .form-status, .contact .link, .contact .field__input, .contact .field__label, .contact .form__label').forEach(function (el) {
      el.style.color = '#1c1a18';
      el.style.opacity = '1';
    });

    document.querySelectorAll('.contact .field__input').forEach(function (el) {
      el.style.background = '#ffffff';
      el.style.borderColor = '#6b5b52';
      el.style.webkitTextFillColor = '#1c1a18';
    });

    document.querySelectorAll('.contact .button').forEach(function (el) {
      el.style.background = '#1e1815';
      el.style.color = '#ffffff';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    redirectStaleHomeCache();
    hardenInternalLinks();
    hardenRenderedAccessibility();
    initMenu();
    initA11y();
    initAddToCart();
    initGallery();
    initProductForm();
    window.setTimeout(hardenRenderedAccessibility, 250);
    window.setTimeout(hardenRenderedAccessibility, 1000);
  });

  if (document.readyState !== 'loading') {
    redirectStaleHomeCache();
    hardenInternalLinks();
    hardenRenderedAccessibility();
  }
})();
